/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessPathStructure } from './AccessPathStructure';
import type { InternationalTextStructure } from './InternationalTextStructure';
import type { SituationFullRefStructure } from './SituationFullRefStructure';
import type { TrackSectionStructure } from './TrackSectionStructure';

export type NavigationSectionStructure = {
  trackSection?: TrackSectionStructure;
  turnDescription?: InternationalTextStructure;
  manoeuvre?: NavigationSectionStructure.manoeuvre;
  turnAction?: NavigationSectionStructure.turnAction;
  directionHint?: InternationalTextStructure;
  bearing?: number;
  accessPath?: AccessPathStructure;
  situationFullRef?: Array<SituationFullRefStructure>;
};

export namespace NavigationSectionStructure {
  export enum manoeuvre {
    ORIGIN = 'ORIGIN',
    DESTINATION = 'DESTINATION',
    CONTINUE = 'CONTINUE',
    KEEP = 'KEEP',
    TURN = 'TURN',
    LEAVE = 'LEAVE',
    ENTER = 'ENTER',
  }

  export enum turnAction {
    SHARP_LEFT = 'SHARP_LEFT',
    LEFT = 'LEFT',
    HALF_LEFT = 'HALF_LEFT',
    STRAIGHT_ON = 'STRAIGHT_ON',
    HALF_RIGHT = 'HALF_RIGHT',
    RIGHT = 'RIGHT',
    SHARP_RIGHT = 'SHARP_RIGHT',
    UTURN = 'UTURN',
  }
}
